import { Box, Paper, Typography } from "@mui/material";
import { motion } from "framer-motion";

interface CardProps {
  icon: React.ReactNode;
  item: {
    title: string;
    description: string;
  };
  idx: number;
  isBlue?:boolean;
}

export default function Card({ icon, item, idx, isBlue=false }: CardProps) {
  return (
      <Paper
         component={motion.div}
                whileHover={{ y: -10 }}
                elevation={0}
        sx={{
          p: 5,
          height: "100%",
          borderRadius: 8,
          border: "1px solid #f1f5f9",
          bgcolor: !isBlue ? "#ffffff" :"#f8fafc",
          transition: "all 0.3s ease",
          "&:hover": {
            bgcolor: "white",
            transform: "translateY(-8px)",
            boxShadow: "0 25px 50px -12px rgba(104, 168, 222, 0.15)",
            borderColor: "#68a8de",
          },
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: 3,
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: !isBlue ? "linear-gradient(135deg, rgba(104, 168, 222, 0.1) 0%, rgba(104, 168, 222, 0.1) 100%)" : "linear-gradient(135deg, #68a8de 0%, #0056b3 100%)",
            color: !isBlue ?  "#68a8de" : "white",
          }}
        >
          {icon}
        </Box>
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: "#0A1128", mb: 2 }}
        >
          {item.title}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", lineHeight: 1.8, fontSize: "0.95rem" }}
        >
          {item.description}
        </Typography>
      </Paper>
  );
}
